import { Autocomplete, CircularProgress, FormControl, InputLabel, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import Geonames from "geonames.js";

interface SelectStateProps {
  value?: number;
  onChange: (value?: number) => void;
  countryId?: number;
  name: string;
  label: string;
  id: string;
}

const geonames = Geonames({
  username: "salvadorlekan",
  lan: "en",
  encoding: "JSON",
});

function SelectState({ value, onChange, countryId = 2328926, ...props }: SelectStateProps) {
  const { data, isLoading } = useQuery(["STATES", countryId], () => geonames.children({ geonameId: countryId }), {
    staleTime: Infinity,
    refetchInterval: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const [open, setIsOpen] = useState(false);

  const [state, setState] = useState<CountryState | null>(
    () => data?.geonames?.find((state: CountryState) => state.geonameId === value) || null
  );

  useEffect(
    () => {
      onChange(state?.geonameId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state?.geonameId]
  );
  return (
    <FormControl fullWidth variant="standard">
      <InputLabel
        sx={{
          fontSize: "1.2rem",
          mb: "0.5rem",
        }}
        htmlFor={props.id}
        shrink>
        {props.label}
      </InputLabel>
      <Autocomplete
        fullWidth
        open={open}
        onOpen={() => {
          setIsOpen(true);
        }}
        onClose={() => {
          setIsOpen(false);
        }}
        value={state}
        isOptionEqualToValue={(option, value) => option.geonameId === value.geonameId}
        getOptionLabel={(option) => option.toponymName}
        options={data?.geonames || []}
        loading={isLoading}
        onChange={(event, newValue) => {
          setState(newValue);
        }}
        renderInput={(params) => (
          <TextField
            ref={params.InputProps.ref}
            {...params}
            size="medium"
            sx={[
              {
                mt: 3,
              },
            ]}
            // {...props}
            InputLabelProps={{
              // ...(params.InputLabelProps || {}),
              shrink: true,
              sx: {
                fontSize: "30px",
                marginBottom: "5rem",
                paddingBottom: "5rem",
              },
            }}
            InputProps={{
              // ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
}

export default SelectState;
